<ng-container
  *ngIf="{
    isLogged: isLogged$ | async,
  } as content"
>
  <div class="simple-card product-card">
    @if (product?.refType) {
      <div class="product-type {{ (product?.refType || '').toLowerCase() }}">{{ product.refType }}</div>
    }

    @if (product?.productReferenceType) {
      <div class="product-reference {{ (product?.productReferenceType?.code || '').toLowerCase() }}">
        {{ product.productReferenceType?.label }}
      </div>
    }

    <product-media [product]="product" [urlTarget]="targetURL"></product-media>

    <h3 class="box-product-name" [title]="product.completeName">
      <ng-container *ngIf="!product.isCustom; else checkCompetitor">
        <a
          class="text-common"
          tabindex="0"
          [target]="targetURL"
          [routerLink]="['/p/' + product.code]"
        >
          {{ fixProductName(product.completeName) }}
        </a>
      </ng-container>
    
      <ng-template #checkCompetitor>
        <ng-container *ngIf="product.competitorFlag?.toLowerCase() === 'yes'; else defaultSpan">
          <span class="text-common">
            {{ product.competitorBrand }} - {{ fixProductName(product.name) }}
          </span>
        </ng-container>
      </ng-template>
    
      <ng-template #defaultSpan>
        <span class="text-common">
          {{ fixProductName(product.name) }}
        </span>
      </ng-template>
    </h3>

    <div class="box-details" [ngClass]="{ 'is-logged': content.isLogged }">
      @if (content.isLogged) {
        <p *ngIf="product?.customerPartNumber">
          <span class="title">{{ 'intro.customer' | cxTranslate }}#:</span><span class="value">{{ product?.customerPartNumber }}</span>
        </p>
      }

      <p *ngIf="product?.partNumber">
        <span class="title">{{ 'intro.part' | cxTranslate }}#:</span><span class="value">{{ product?.partNumber }}</span>
      </p>

      <p *ngIf="product?.catalogNumber">
        <span class="title">{{ 'intro.catalog' | cxTranslate }}#:</span><span class="value">{{ product?.catalogNumber }}</span>
      </p>
    </div>

    @if (!product.isCustom) {
      @if (!product.discontinued) {
        <div class="box-price" [ngClass]="{ 'is-logged': content.isLogged }">
          <product-price [InProduct$]="productAsObservable()" [lazyPrice]="lazyPrice"></product-price>
        </div>
      } @else {
        <span class="ff-bold text-danger">
          {{ 'productRow.noLonger' | cxTranslate }}
        </span>
      }
    }

    <div class="actions w-100">
      @if (!product.isCustom) {
        @if (product.discontinued) {
          <product-replacement [product]="product"></product-replacement>
        } @else {
          @if (content.isLogged) {
            <cx-add-to-cart [productCode]="product.code!" [showQuantity]="false"> </cx-add-to-cart>
          } @else {
            <a tabindex="0" [routerLink]="['/where-to-buy']" class="btn btn-primary w-100">
              <span class="d-flex icon material-symbols-outlined m-r-4"> location_on </span>

              {{ 'productRow.actions.whereToBuy' | cxTranslate }}
            </a>
          }
        }
      }
    </div>
  </div>
</ng-container>
